import { useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { SelectField } from 'shared/controls';
import { useCustomerProductNumbers } from 'shared/queries';

interface CustomerProductNumberDropdownProps {
  name: `${string}` | `${string}.${string}` | `${string}.${number}`;
  productId: string;
  customerId: string;
  error?: boolean;
  helperText?: string;
  isNew: boolean;
}
export function CustomerProductNumberDropdown({
  name,
  productId,
  customerId,
  isNew,
  error,
  helperText,
}: CustomerProductNumberDropdownProps) {
  const { setValue } = useFormContext();
  const { options, isLoading, isFetching } = useCustomerProductNumbers(customerId, productId);
  const loading = isFetching || isLoading;
  const defaultValue = useMemo(() => (options?.length === 1 ? options[0] : ''), [options]);

  useEffect(() => {
    if (defaultValue) {
      setValue(name, defaultValue);
    }
  }, [setValue, defaultValue, name]);

  return (
    <SelectField
      name={name}
      label='Customer Product Number'
      options={options || []}
      disabled={options?.length === 1}
      getOptionLabel={option => option}
      getOptionSelected={(option, value) => option === value}
      loading={loading}
      error={error}
      helperText={helperText}
    />
  );
}
